var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from '@emotion/styled';
export var EmojiStyled = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: 1.2rem;\n  line-height: 1.2rem;\n  display: inline-block;\n  margin: 0 0.3rem;\n"], ["\n  font-family: ", ";\n  font-size: 1.2rem;\n  line-height: 1.2rem;\n  display: inline-block;\n  margin: 0 0.3rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.emoji;
});
export var Emoji = function (_a) {
    var _b = _a.symbol, symbol = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, props = __rest(_a, ["symbol", "label"]);
    return (<EmojiStyled role="img" aria-label={label} title={label} {...props}>
      {symbol}
    </EmojiStyled>);
};
var templateObject_1;
